'use client'; // Error boundaries must be Client Components

import '@alltrails/layout/styles/globals.scss'; // global-error replaces RootLayout entirely, so design tokens, font-faces, and CSS resets aren't loaded unless we import them here.
import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import ErrorContentBody from './ErrorContentBody';
import styles from './errors.module.scss';

// > Global error UI must define its own <html> and <body> tags, since it is replacing the root layout or template when active.
// > - https://nextjs.org/docs/app/getting-started/error-handling#global-errors

// > It [error.js] does not wrap the layout.js or template.js above it in the same segment. To handle errors in the root layout, use global-error.js.
// > - https://nextjs.org/docs/app/api-reference/file-conventions/error

// global-error renders outside the React boundary — no server-provided locale, no redux store, no app-level providers.
// We render ErrorContentBody (visual content only) plus a plain anchor for the recovery link to avoid pulling in any redux-dependent components like Denali's Button.
// IntlProvider with empty messages lets FormattedMessage fall back to its inline defaultMessage (English) — an acceptable fallback for a catastrophic-error page.
export default function GlobalErrorPage({ error }: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  useEffect(() => {
    console.log(`Rendering mugen GlobalErrorPage for app: "${process.env.NEXT_PUBLIC_APP_NAME}" with error digest: ${error.digest}`);
  }, [error.digest]);

  return (
    <html>
      <body>
        <IntlProvider locale="en-US" messages={{}}>
          <div className={styles.container}>
            <ErrorContentBody />
            <div className={styles.buttonContainer}>
              <a href="/explore">Find your next trail</a>
            </div>
          </div>
        </IntlProvider>
      </body>
    </html>
  );
}
